import { __awaiter } from "tslib";
/**
 * 出价记录组件（非弹窗
 * ）
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import { setKey } from '@/shared/functions';
import API from '@/services';
const resetData = {
    id: null,
    tableRowkey: 'key',
    tableData: [],
    tableColumn: [],
    pageIndex: 0,
    pageSize: 10,
    total: 0,
    pageIndexAuction: 0,
    totalAuction: 0,
    visible: false,
    activeTab: '1',
    loading: false,
    offerAuctionMode: null,
    offerSessionMsg: {},
};
export default createStore({
    state: Object.assign({}, resetData),
    effects: {
        updateData({ index, auctionId, size }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id, pageSize, offerAuctionMode } = state;
                this.SET_STATE({
                    loading: true,
                });
                if (id !== auctionId || !offerAuctionMode) {
                    yield this.getAuctionType(auctionId);
                }
                this.getOffer({
                    pageIndex: index,
                    pageSize: size || pageSize,
                    id: auctionId,
                    isHidden: 0,
                });
            });
        },
        getOffer(params, { state }) {
            const { pageIndex, pageSize, id } = params;
            const { offerAuctionMode } = state;
            switch (offerAuctionMode) {
                case 1011:
                case 1021:
                    this.offerSuperUpdate({
                        pageIndex,
                        pageSize,
                        auctionId: id,
                    });
                    break;
                default:
                    this.offerUpdate({
                        pageIndex,
                        pageSize,
                        auctionId: id,
                        type: 0,
                    });
            }
        },
        getAuctionType(auctionId) {
            return __awaiter(this, void 0, void 0, function* () {
                yield API.auction.getAuctionBaseInfo({
                    auctionId,
                })
                    .then((res) => {
                    const { auctionMode } = res;
                    this.SET_STATE({
                        id: auctionId,
                        offerAuctionMode: auctionMode,
                        offerSessionMsg: res,
                    });
                });
            });
        },
        offerUpdate(params, { state }) {
            const { activeTab } = state;
            API.auction.bidRecord(Object.assign(Object.assign({}, params), { isHidden: 0 }))
                .then((res) => {
                if (activeTab === '2') {
                    this.SET_STATE({
                        tableData: setKey(res.items || []),
                        pageIndexAuction: res.currentIndex,
                        totalAuction: res.totalNumber,
                        visible: true,
                    });
                }
                else {
                    this.SET_STATE({
                        tableData: setKey(res.items || []),
                        pageIndex: res.currentIndex,
                        total: res.totalNumber,
                        visible: true,
                    });
                }
            })
                .catch(() => {
                notification.error({
                    message: '出价记录请求失败，请重试！',
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loading: false,
                });
            });
        },
        offerSuperUpdate(params, { state }) {
            this.offerUpdate(Object.assign(Object.assign({}, params), { type: state.activeTab, isHidden: 0 }));
        },
        changeTab(activeKey, { state }) {
            this.SET_STATE({
                activeTab: activeKey,
            });
            this.updateData({ index: 1, auctionId: state.id });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        resetState(state) {
            Object.keys(resetData).forEach((key) => {
                state[key] = resetData[key];
            });
        },
    },
});
